// axios 配置
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store/index'

// api地址
const url = process.env.VUE_APP_BASE_API

// 创建axios实例
const service = axios.create({
  baseURL: url
})
// 请求拦截器 request interceptor
service.interceptors.request.use(
  config => {
    config.baseURL = config.url.indexOf('mock') !== -1 ? '/' : url
    config.headers.Culture = store.getters.language === 'zh' ? 'zh-cn' : 'en-us'
    config.headers.OpenID = 'D43AFC6F548E439BBE5230ED2D6C0692'
    if (config.headers['magnum-token']) {
      config.headers.Token = '26A24B0812A941ABB793F339393EF535'
    } else {
      config.headers.Token = store.getters.token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器 response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status === '9008') {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).then(() => {
        if (store.state.user.flag === 1) {
          store.dispatch('user/logout').then(() => {
            location.href = '/login'
          })
        } else {
          store.dispatch('user/logoutmeter').then(() => {
            location.href = '/loginmeter'
          })
        }
      }).catch(() => { })
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (res.status !== '0') {
      Message({
        message: res.message,
        type: 'warning',
        duration: 1.5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: '服务器数据错误，请稍候再试',
      type: 'error',
      duration: 1.5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
